import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import i18n from 'i18n-js';
import React from 'react';
import ModalBase from './ModalBase';
import BasicButton from "./BasicButton";
import CancelButton from "./CancelButton";

export default function ModalFrame(props) {
    
    return (
        <ModalBase showModal={props.showModal}>
            <Text className="text-2xl leading-2xl text-secondary-900">{i18n.t(props.title)}</Text>
            <Text className="text-xl leading-2xl text-secondary-900">{i18n.t(props.text)}</Text>
            <VStack space='md' className="items-center bg-secondary-50 w-[100%]">
                {props.children}
            </VStack>
            <VStack space='md' className="pt-3 w-[100%]">
                <BasicButton onPress={() => props.onClose(true)} text={i18n.t('appSettings.saving')} />
                <CancelButton onPress={() => props.onClose(false)} text={i18n.t('appSettings.cancel')} />
            </VStack>
        </ModalBase>
    );
}